const productMenuInit = (field: HTMLInputElement) => {
  setTimeout(() => {
    const summary = document.querySelector('.summary');
    let price = summary.querySelector('.woocommerce-variation');
    if (!price) {
      price = document.querySelector('.price');
    }

    if (price) {
      const callback = (mutationList) => {
        mutationList.forEach((mutation) => {
          if (mutation.type === 'childList') {
            setTimeout(() => {
              const group = price.querySelector('ins');

              if (group) {
                const discount = group.querySelector('bdi');
                const clone = discount.cloneNode(true) as HTMLElement;
                const decimalElm = clone.querySelector('.price-decimal');
                const symbolElm = clone.querySelector('.woocommerce-Price-currencySymbol');
                const decimal = decimalElm.innerHTML;
                symbolElm.remove();
                decimalElm.remove();
                const truePrice = clone.innerHTML.replace('€&nbsp;', '');
                field.setAttribute('value', truePrice + decimal);

                const varPrice = document.querySelector('.var_price');
                if (varPrice) {
                  const varPricegGroup = varPrice.querySelector('ins');
                  varPricegGroup.innerHTML = group.innerHTML;
                }
              }
            }, 100);
          }
        });
      };

      const observerOptions = {
        childList: true,
        attributes: true,
        subtree: true,
      };
      const observer = new MutationObserver(callback);
      observer.observe(price, observerOptions);
    }
  }, 100);
};

export default productMenuInit;
